<template>
  <div>
    <v-container>
      <div class="text-xs-right">
        <v-btn @click="onAddLine" outline color="#00c300" style="text-transform: none"
          ><em class="fab fa-line mr-2" style="font-size: 22px" /> Add Line</v-btn
        >

        <v-btn @click="onSignIn" outline color="#1677c5" style="text-transform: none"
          ><em class="fab fa-facebook-square mr-2" style="font-size: 22px" /> Add Page</v-btn
        >

        <v-btn @click="onSignInIG" outline color="#C13584" style="text-transform: none"
          ><em class="fab fa-instagram mr-2" style="font-size: 22px" /> Add IG</v-btn
        >
      </div>
      <div>
        <v-btn
          @click="changeApp('all')"
          color="grey"
          :dark="filter.app == 'all'"
          :outline="filter.app != 'all'"
          >All</v-btn
        >
        <v-btn
          @click="changeApp('facebook')"
          color="#1677c5"
          :dark="filter.app == 'facebook'"
          :outline="filter.app != 'facebook'"
          >Facebook</v-btn
        >
        <v-btn
          @click="changeApp('line')"
          color="green"
          :dark="filter.app == 'line'"
          :outline="filter.app != 'line'"
          >Line OA</v-btn
        >

        <v-btn
          @click="changeApp('instagram')"
          color="#C13584"
          :dark="filter.app == 'instagram'"
          :outline="filter.app != 'instagram'"
          >Instagram</v-btn
        >
      </div>
      <div>
        <v-layout row wrap class="ma-0 ma-0">
          <v-flex xs6>
            <multiselect
              placeholder="เลือกกลุ่ม"
              label="name"
              @input="onChangeGroupFilter"
              :options="groupOptions"
              :show-labels="false"
              v-model="filter.groupId"
            ></multiselect>
          </v-flex>
          <v-flex xs1></v-flex>
          <v-flex xs5>
            <div style="position: relative" class="form-control">
              <input @keyup.enter="getData" type="text" v-model="filter.search" />
              <v-btn
                @click="getData"
                style="position: absolute; right: 2px; top: 0px"
                icon
                color="primary"
                flat
              >
                <v-icon>search</v-icon>
              </v-btn>
            </div>
          </v-flex>
          <v-flex xs12>
            <div class="mb-3">
              <v-pagination
                :total-visible="15"
                v-model="pageNumber"
                @input="changePage"
                :length="pagelength"
              ></v-pagination>
            </div>
            <div v-if="loading" class="mt-3 text-xs-center">
              <v-progress-circular indeterminate color="primary" size="70"></v-progress-circular>
            </div>
            <div v-else>
              <div v-if="!data.length">
                <div class="text-xs-center mt-5">
                  <span style="color: grey; font-size: 20px">ไม่พบข้อมูล</span>
                </div>
              </div>
              <div v-else>
                <div
                  @click="showDetail(item)"
                  v-ripple
                  v-for="item in data"
                  :key="item.id"
                  style="border: 1px solid grey; border-radius: 8px; cursor: pointer"
                  class="py-2 px-2 pl-4 mb-3"
                >
                  <v-layout row wrap class="ma-0">
                    <v-flex xs4>
                      <div style="display: flex; align-items: center">
                        <span class="mr-3" style="font-size: 39px">
                          <em
                            v-if="item.app == 'facebook'"
                            style="color: #4267b2"
                            class="fab fa-facebook-square"
                          />
                          <em
                            v-if="item.app == 'instagram'"
                            style="color: #c13584"
                            class="fab fa-instagram"
                          />
                          <em
                            v-if="item.app == 'line'"
                            style="color: #00c300"
                            class="fab fa-line"
                          />
                        </span>
                        <span> {{ item.channelname }}</span>
                      </div>
                    </v-flex>
                    <v-flex xs6 style="display: flex; align-items: center">
                      <div style="width: 100%">
                        <v-layout row wrap class="ma-0">
                          <v-flex xs6>
                            <v-chip small v-for="(group, index) in getGroupName(item)" :key="index">
                              {{ group }}
                            </v-chip>
                          </v-flex>
                          <v-flex
                            xs6
                            class="primary--text threelinetruncate"
                            style="font-size: 13px"
                          >
                            <div>
                              {{ item.signature }}
                            </div>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-flex>
                    <v-flex
                      xs2
                      style="display: flex; align-items: center; justify-content: flex-end"
                    >
                      <div>
                        <v-btn @click.stop="showEdit(item)" flat icon color="primary">
                          <v-icon>edit</v-icon>
                        </v-btn>
                        <v-btn @click.stop="deleteItem(item)" flat icon color="primary">
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </div>
                    </v-flex>
                  </v-layout>
                </div>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </div>
    </v-container>
    <v-dialog v-model="modalDetail" width="650px" persistent>
      <v-card v-if="modalDetail">
        <ChannelDetail @close="modalDetail = false" :detailData="detailData"></ChannelDetail>
      </v-card>
    </v-dialog>
    <v-dialog v-model="botlistDialog" width="650px" persistent>
      <v-card id="get-started" v-if="botlistDialog">
        <PageList
          :key="channel"
          :showAll="channel == 'instagram'"
          :channel="channel"
          @onsave="onAddFacebookPage"
          @close="botlistDialog = false"
        ></PageList>
      </v-card>
    </v-dialog>
    <v-dialog content-class="overflowYvisible" v-model="editModal" width="650px" persistent>
      <v-card v-if="editModal">
        <ChannelManagerEdit
          :groupOptions="groupOptions"
          :channel="channel"
          @onsave="onsaveEditModal"
          @close="editModal = false"
          :editdata="editdata"
          :edittype="edittype"
        >
        </ChannelManagerEdit>
      </v-card>
    </v-dialog>
    <v-dialog v-model="successModal" width="550px" persistent>
      <v-card>
        <div v-if="successLoading" class="text-xs-center pa-5">
          <v-progress-circular indeterminate color="primary" size="80"></v-progress-circular>
        </div>
        <div v-else class="pt-5 pb-3">
          <div class="pa-3">
            <div class="text-xs-center">
              <em style="font-size: 70px" class="fas fa-check-circle primary--text" />
            </div>
            <div style="font-size: 20px" class="text-xs-center mt-3">การเชื่อมต่อสำเร็จ</div>
            <div class="text-xs-center mt-5">
              <v-btn @click="successNext" depressed color="primary">ถัดไป</v-btn>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="lineAddModal" width="650px" persistent>
      <v-card v-if="lineAddModal">
        <LineAdd @close="lineAddModal = false" @onsave="onSaveLine"></LineAdd>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ChannelDetail from './ChannelDetail.vue'
import config from '@/config'
import PageList from './PageList.vue'
import LineAdd from './LineAdd.vue'
import ChannelManagerEdit from './ChannelManagerEdit.vue'
import api from '@/api'
import { mapGetters } from 'vuex'
import multiselect from 'vue-multiselect'
window.fbAsyncInit = function () {
  // eslint-disable-next-line no-undef
  FB.init({
    appId: config.appid,
    cookie: true, // enable cookies to allow the server to access the session
    xfbml: true, // parse social plugins on this page
    version: 'v4.0'
    // auth: true
  })
}
;(function (d, s, id) {
  // eslint-disable-next-line one-var
  var js,
    fjs = d.getElementsByTagName(s)[0]
  if (d.getElementById(id)) return
  js = d.createElement(s)
  js.id = id
  js.src = 'https://connect.facebook.net/en_US/sdk.js'
  fjs.parentNode.insertBefore(js, fjs)
})(document, 'script', 'facebook-jssdk')

export default {
  components: {
    PageList,
    ChannelManagerEdit,
    ChannelDetail,
    multiselect,
    LineAdd
  },
  data() {
    return {
      channel: '',
      lineAddModal: false,
      loading: false,
      groupOptions: [],
      modalDetail: false,
      detailData: '',
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      successModal: false,
      successLoading: false,
      editdata: '',
      edittype: 'create',
      editModal: false,
      filter: {
        app: 'all',
        search: ''
      },
      data: [],
      botlistDialog: false,
      fbSignInParams: {
        scope: this.fb_scope,
        return_scopes: true
      },
      filter: {
        groupId: '', // optional
        app: 'all', // optional
        search: '' // optional (ชื่อเพจ)
      }
    }
  },
  computed: {
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / 10)
      } else {
        return 1
      }
    },
    ...mapGetters(['selectedBot']),
    fb_scope() {
      if (this.channel == 'instagram') {
        return (
          config.fb_scope +
          ',instagram_basic,instagram_manage_messages,instagram_manage_comments,instagram_content_publish,pages_read_engagement,pages_show_list'
        )
      } else return config.fb_scope
    }
  },
  mounted() {
    this.getData(false)
    this.getGroups()
  },
  methods: {
    deleteItem(item) {
      var data = {
        pageid: this.selectedBot.pageid,
        channelId: item.channelid,
        app: item.app
      }
      this.$swal
        .fire({
          text: 'ยืนยันการลบ ?',
          showCancelButton: true
        })
        .then((result) => {
          if (result.value) {
            this.loading = true
            api.deletePowerbuyChannel(data, (err, response) => {
              this.loading = false
              if (response.responsecode == 200) {
                this.$swal.fire({
                  text: 'ลบสำเร็จ'
                })
                this.getData()
              }
            })
          }
        })
    },
    onSaveLine(channelid) {
      this.edittype = 'line'
      this.channel = 'line'
      this.editdata = { channelid }
      this.editModal = true
      this.lineAddModal = false
    },
    onAddLine() {
      this.lineAddModal = true
    },
    onChangeGroupFilter() {
      this.getData()
    },
    changeApp(item) {
      this.filter.app = item
      this.getData()
    },
    getGroupName(item) {
      var groupids = item.groupids

      var data = this.groupOptions.filter((el) =>
        groupids ? groupids.includes(parseInt(el.id)) : false
      )
      return data && data.length ? data.map((el) => el.name) : '-'
    },
    getGroups() {
      var data = {
        pageid: this.selectedBot.pageid
      }
      api.getPowerbuyGroup(data, (err, response) => {
        this.groupOptions = response.data.map((el) => {
          return { ...el, id: parseInt(el.id) }
        })
      })
    },
    showDetail(item) {
      this.detailData = item
      this.modalDetail = true
    },
    showEdit(item) {
      this.channel = item.app
      this.edittype = 'edit'
      this.editdata = item
      this.editModal = true
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getData(false)
      }
    },
    getData(refresh = true) {
      if (refresh) {
        this.offset = 0
        this.pagetmp = 1
        this.pageNumber = 1
      }
      var data = {
        pageid: this.selectedBot.pageid, // pageid ที่เข้ามาจาก cms
        limit: this.limit,
        offset: this.offset
      }
      for (const key in this.filter) {
        if (this.filter[key]) {
          if (key == 'app' && this.filter[key] == 'all') {
          } else if (key == 'groupId') {
            Object.assign(data, { [key]: this.filter[key].id })
          } else {
            Object.assign(data, { [key]: this.filter[key] })
          }
        }
      }
      this.loading = true
      api.powerbuyGetChannel(data, (err, response) => {
        this.loading = false
        this.data = response.data
        this.total = parseInt(response.total)
      })
    },
    onsaveEditModal() {
      this.editModal = false
      this.getData()
    },
    successNext() {
      this.edittype = 'edit'
      this.successModal = false
      if (this.channel != 'instagram') this.editModal = true
      this.getData()
    },
    onAddFacebookPage({ pageid, pagename }) {
      this.botlistDialog = false
      this.successModal = true
      this.successLoading = true
      var data = { pageid }
      api.postinsertusersfrominbox(data, (err, response) => {
        if (response.responsecode == 200) {
          api.postinsertusersfromdone(data, (err, res) => {
            if (res.responsecode == 200) {
              switch (this.channel) {
                case 'facebook':
                  api.powerbuyAddChannelFacebook(
                    { pageid: this.selectedBot.pageid, channelId: pageid, pagename },
                    (err, result) => {
                      if (result.responsecode == 200) {
                        this.editdata = {
                          channelid: pageid
                        }
                        this.successLoading = false
                      } else {
                        this.successLoading = false
                        this.successModal = false
                      }
                    }
                  )
                  break
                case 'instagram':
                  api.powerbuyAddChannelInstagram(
                    { pageid: this.selectedBot.pageid, channelId: pageid, pagename },
                    (err, result) => {
                      if (result.responsecode == 200) {
                        this.editdata = {
                          channelid: pageid
                        }
                        this.successLoading = false
                      } else {
                        this.successLoading = false
                        this.successModal = false
                      }
                    }
                  )

                  break
                default:
                  break
              }
            }
          })
        }
      })

      //
    },
    async onSignIn() {
      try {
        this.channel = 'facebook'
        let response = await this.getFBToken()
        this.onSignInSuccess(response)
      } catch (error) {
        console.error(error)
      }
    },
    async onSignInIG() {
      try {
        this.channel = 'instagram'
        let response = await this.getFBToken()
        this.onSignInSuccess(response)
      } catch (error) {
        console.error(error)
      }
    },
    getFBToken() {
      let vm = this
      return new Promise((resolve, reject) => {
        vm.$set(vm.fbSignInParams, 'scope', vm.fb_scope)
        FB.getLoginStatus(async (res) => {
          if (res.status === 'connected') {
            await FB.logout()
          }
          FB.login((response) => {
            if (response.status === 'connected') {
              var isAuth = vm.validateScope(response)
              if (isAuth && response.status === 'connected') {
                resolve(response)
              }
            }
            reject()
          }, vm.fbSignInParams)
        })
      })
    },
    validateScope: function (response) {
      var scopes = this.fb_scope.replace(' ', '').split(',')

      if (response.authResponse.grantedScopes) {
        if (scopes.length > 0) {
          scopes.map(function (scope) {
            if (!response.authResponse.grantedScopes.includes(scope)) {
              return false
            }
          })
        }
      } else {
        return false
      }

      return true
    },
    onSignInSuccess(response) {
      let vm = this

      var isAuth = vm.validateScope(response)
      if (!isAuth) {
        vm.showTurnOnPermission = true
        return false
      }

      if (response.status === 'connected') {
        // this.botlistDialog = true
        vm.$store
          .dispatch('loginFBPowerbuy', {
            accessToken: response.authResponse.accessToken,
            userid: response.authResponse.userID,
            channel: 'facebook',
            scope: this.fb_scope
          })
          .then(() => {
            this.botlistDialog = true
          })
      } else {
        this.$swal.fire({
          text: 'Unable to connect Facebook'
        })
      }
    }
  }
}
</script>

<style lang="scss">
.threelinetruncate {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.overflowYvisible {
  overflow-y: visible !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/powerbuy/Management/ChannelManager.vue